import { combineReducers, configureStore } from '@reduxjs/toolkit'
//import { ThunkAction } from 'redux-thunk'
// import rootReducer, { RootState } from 'app/rootReducer'
// import rootReducer from '../reducers'
// Import the `thunk` middleware

import { logger } from 'utils/logger';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import authReducer from "../modules/Auth/authSlice";
import homeReducer from "../modules/Home/homeSlice";
import distributionReducer from "../modules/Distributions/distributionSlice";
import wipReducer from "../modules/Wip/wipSlice";
import approvalReducer from "../modules/Approval/approvalSlice";
import talentReducer from "../modules/Talent/talentSlice";
import liveFeedReducer from "../modules/LiveFeed/liveFeedSlice";
import appReducer from '../app/appSlice';
import persistReducer from 'redux-persist/es/persistReducer';
import persistStore from 'redux-persist/es/persistStore';
import settingsReducer from '../modules/Settings/settingsSlice';
import { thunk } from 'redux-thunk';

const stateName = `${process.env.NODE_ENV}_persistantState`


const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['homeReducer', 'distributionReducer', 'wipReducer', 'talentReducer','liveFeedReducer', 'approvalReducer'],
};

const homePersistConfig = {
  key: 'homeReducer',
  storage: storage,
  whitelist: ['displayPrefs', 'wipFilter', 'styleFilter', 'styleMediaFilter'],
};

const distPersistConfig = {
  key: 'distributionReducer',
  storage: storage,
  whitelist: ['displayPrefs', 'wipFilter', 'styleFilter', 'styleMediaFilter'],
};

const wipPersistConfig = {
  key: 'wipReducer',
  storage: storage,
  whitelist: ['displayPrefs', 'wipFilter', 'styleFilter', 'styleMediaFilter'],
};

const approvalPersistConfig = {
  key: 'approvalReducer',
  storage: storage,
  whitelist: ['displayPrefs', 'wipFilter', 'styleFilter', 'styleMediaFilter'],
};


const talentPersistConfig = {
  key: 'talentReducer',
  storage: storage,
  whitelist: ['displayPrefs', 'talentFilter'],
};

const liveFeedPersistConfig = {
  key: 'liveFeedReducer',
  storage: storage,
  whitelist: ['displayPrefs'],
};

const settingsPersistConfig = {
  key: 'settingsReducer',
  storage: storage,
  whitelist: ['keywordHighlighting', 'theme'],
};


export function clearLocalStorage() {
  logger.log('clearing local storage')
  localStorage.removeItem(stateName);
}


// this is your global config
const rootReducer = combineReducers({
  homeReducer: persistReducer(homePersistConfig, homeReducer),
  distributionReducer: persistReducer(distPersistConfig, distributionReducer),
  wipReducer: persistReducer(wipPersistConfig, wipReducer),
  talentReducer: persistReducer(talentPersistConfig, talentReducer),
  liveFeedReducer: persistReducer(liveFeedPersistConfig, liveFeedReducer),
  approvalReducer: persistReducer(approvalPersistConfig, approvalReducer),
  settingsReducer: persistReducer(settingsPersistConfig, settingsReducer),
  appReducer: appReducer,
  auth: authReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    devTools: false,
    // middleware: [thunk],
});

export const persistor = persistStore(store);